/*
RAW POINT DATA:
"latitude": "28.568140002231328",
"longitude": "-81.80522291737506",
"name": "Wicked Motorsports",
"phone": "(352) 989-5922",
"mail": "",
"rating": "",
"address": "1516 Max Hooks Rd SUITE J, Groveland, FL 34736",
"site": "https://www.wickedmotorsfl.com/",
"working_hours": [],
"category_codes": [],
"store_type_code": null,
"city_id": 219,
"country_id": 120
"point_color": "black"
*/

import {CATEGORIES_DATA, DEFAULT_POINT_IMG, POINT_IMAGES, SHOP_TYPES_DATA, SMALL_POINTS} from "./data";

export class PointsParser {
  
  _parserId;
  _lastPointParseId = 0;
  
  constructor(parserId = '') {
    this._parserId = parserId;
  }
  parse(points) {
    if (!Array.isArray(points)) {
      console.error('Неверный тип данных', points);
      return []
    }
    return points.map(el => this._parseElement(el)).filter(el => !!el);
  }
  
  _parseElement(el) {
    if (!el || typeof el !== 'object') {
      console.error('Неверный тип данных', el);
      return null
    }
    
    const myId = this._lastPointParseId;
    this._lastPointParseId = this._lastPointParseId + 1;
    
    const id = `${this._parserId}-${myId}`;
    const lat = parseFloat(el.latitude);
    const lng = parseFloat(el.longitude);
    
    if (!lat || !lng || isNaN(lat) || isNaN(lng)) {
      console.error('Ошибка парсинга координат точки', el);
      return null
    }
    return {
      id,
      coordinates: { lat, lng },
      name: el.name,
      raw: el,
      icon: this._getElementIcon(el),
      achievements: this._getElementAchievements(el)
    }
  }
  
  _getElementAchievements(elem) {
    const result = [];
    [...SHOP_TYPES_DATA, ...CATEGORIES_DATA].filter(el => el.showInCard).forEach(el => {
      if (elem[el.code]) {
        result.push(el.cardImg);
      }
    })
    return result;
  }
  
  _getElementIcon(elem) {
    const icon = {
      ...DEFAULT_POINT_IMG
    }
    for (let i = POINT_IMAGES.length - 1; i >= 0; i--) {
      const data = POINT_IMAGES[i];
      let active = true;
      for (let key in data.filter) {
        if (elem[key] !== data.filter[key]) {
          active = false;
        }
      }
      if (active) {
        return {
          active: data.active,
          inactive: data.inactive,
          small: SMALL_POINTS[elem?.point_color] ?? data.small,
        }
      }
    }
    return {
      ...icon,
      small: SMALL_POINTS[elem?.point_color] ?? icon.small
    }
  }
}


